/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomfieldsComponent } from '../components/customfields/customfields.component';
import { BooleanFieldComponent } from '../components/customfields/booleanfield.component';
import { CurrencyFieldComponent } from '../components/customfields/currencyfield.component';
import { DateFieldComponent } from '../components/customfields/datefield.component';
import { HyperlinkFieldComponent } from '../components/customfields/hyperlinkfield.component';
import { NumberFieldComponent } from '../components/customfields/numberfield.component';
import { StringFieldComponent } from '../components/customfields/stringfield.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule ,
    ReactiveFormsModule
  ],
  declarations: [ CustomfieldsComponent, BooleanFieldComponent, CurrencyFieldComponent,
    DateFieldComponent, HyperlinkFieldComponent, NumberFieldComponent, StringFieldComponent],
    exports: [CustomfieldsComponent, CommonModule]
})
export class CustomfieldsModule { }
